/**
 * useSSE — React wrapper around sseHub.subscribe.
 *
 * Subscribes to a single SSE event name on mount, unsubscribes on unmount.
 * Consumers should pass any captured values via `deps` so the handler resets
 * when those values change (matches useEffect semantics).
 */
import { useEffect } from 'react';
import { sseHub } from '../services/sseHub';

export function useSSE<T = any>(
  eventType: string,
  handler: (data: T) => void,
  deps: any[] = [],
): void {
  useEffect(() => {
    const unsubscribe = sseHub.subscribe<T>(eventType, handler);
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventType, ...deps]);
}

export default useSSE;
